import { Injectable } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as SharedActions from '../actions/shared.actions';
import { getUserSession } from '../adapters/user-session.adapter';

@Injectable()
export class SiteWideUserSessionEffects {
  loadSiteWideUserSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.loadSiteWideUserSession),
      switchMap(() =>
        this.userSessionService.getUserSession().pipe(
          map((dashboardData) =>
            SharedActions.loadSiteWideUserSessionSuccess({
              session: {
                id: 'sitewide-user-session',
                sitewideUserSession: getUserSession(dashboardData)
              }
            })
          ),
          catchError((error) => {
            return of(
              SharedActions.loadSiteWideUserSessionFailure({
                error
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly userSessionService: UserSessionService
  ) {}
}
